import React from "react";
import { detect } from "detect-browser";
import SampleRegistration from "./SampleRegistration";

export default function ShoppingCartWrapper(props) {
  const browser = detect();
  if (browser) {
    console.log(browser.name);
    console.log(browser.version);
    console.log(browser.os);
  }
  return <SampleRegistration {...props} />;
}
